'use client';

import { useState } from 'react';

import type { ReferSubscriptionDialogProps } from '@wwe-portal/ui/features/club-store/dialog/refer-subscription-dialog';

export const useReferSubscriptionState = ({
  onReferSubscription,
}: {
  onReferSubscription: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const [description, setDescription] = useState<React.JSX.Element>();
  const props: ReferSubscriptionDialogProps & {
    show: () => void;
    setDescription: (value: React.JSX.Element) => void;
  } = {
    onChange: onReferSubscription,
    show: () => {
      setOpen(true);
    },
    onClose: () => {
      setOpen(false);
    },
    setDescription,
    description,
    open,
  };
  return props;
};
